module.exports = __webpack_public_path__ + "static/img/wechat2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat2.png
// module id = h+LZ
// module chunks = 0